import { useState } from "react"
import { router } from "@inertiajs/react"
import { Form, Input } from "./Form"
import Button from "./Button"

const LoginForm = ({ email }: { email: string }) => {
  const [isSubmitting, setIsSubmitting] = useState(false)

  const handleLogin = async (session: { email: string }) => {
    setIsSubmitting(true)
    router.post("/login", session, {
      onFinish: () => setIsSubmitting(false),
    })
  }

  return (
    <Form
      defaultValues={{ email }}
      onSubmit={handleLogin}
      className="flex flex-col my-2 lg:flex-row"
    >
      <div className="flex-1">
        <Input
          name="email"
          type="email"
          className="h-12 px-3 text-center lg:text-left"
          placeholder="Enter your email"
          autoComplete="email"
          autoCapitalize="off"
          autoCorrect="off"
          spellCheck="false"
          required
          disabled={isSubmitting}
        />
      </div>
      <div className="mt-2 shrink-0 lg:mt-0 lg:ml-2">
        <Button className="h-12" disabled={isSubmitting}>
          Send login link
        </Button>
      </div>
    </Form>
  )
}

export default LoginForm
